<script setup lang="ts">
import type { NovaBoxCreatorsProps } from './NovaBoxCreators.types'

withDefaults(defineProps<NovaBoxCreatorsProps>(), {
  isLoading: false,
  isError: false,
})
</script>

<template>
  <div v-if="!isLoading && !isError" class="creator-list">
    <slot name="default" />
    <!--    <NovaBoxCreatorsCard
      v-for="creator in creators"
      :key="creator.userSn"
      :creator="creator"
      :ga-slot="gaSlot"
    />-->
  </div>

  <NovaLoadingIndicator
    v-if="isLoading"
    :fill="true"
    :bg-bright="'light'"
    class="loading-indicator"
  />

  <NovaBoxEmptyMessage
    v-if="!isLoading && isError"
    :message="$t('statusMessages.creators.error')"
  />

  <NovaBoxEmptyMessage
    v-if="!isLoading && !isError && !creatorCount"
    :message="$t('statusMessages.creators.empty')"
  />
</template>

<style lang="scss" scoped>
.creator-list {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  -webkit-grid-template-columns: repeat(5, minmax(0, 1fr));
  column-gap: 20px;
  row-gap: 20px;
  padding-top: 12px;

  @include tablet {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    -webkit-grid-template-columns: repeat(4, minmax(0, 1fr));
    column-gap: 20px;
    row-gap: 20px;
  }

  @include mobile {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    -webkit-grid-template-columns: repeat(3, minmax(0, 1fr));
    column-gap: 12px;
    row-gap: 12px;
    padding-top: 10px;
  }
}
</style>
